import React, { useState } from 'react'
import CardInfoCompra from './CardInfo'
import { BackButton } from '../../../../../components/buttons/ButtonDefault';
import { ListGastosTable } from './ListGastosTable';

export const GastosPorCompra = () => {
    const [reload, setReload] = useState(false);
    const [data, setData] = useState(null);
    return (
        <div className='relative'>
            <BackButton />
            <CardInfoCompra
                reload={reload}
                data={data}
                setData={setData}
            />
            <ListGastosTable
                reload={reload}
                setReload={setReload}
                dataCard={data}
            />
        </div>
    )
}